import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function QuickCategoryStrip() {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex items-center gap-2 mb-3.5">
        <i className="ri-apps-2-line text-accent-500 text-lg" />
        <h2 className="text-sm md:text-base font-semibold text-foreground-900 font-heading">分类快捷入口</h2>
      </div>
      <div className="flex flex-wrap gap-2.5 md:gap-3">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.id}`}
            className="group flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3.5 py-2 hover:border-accent-300 hover:bg-accent-50 transition-colors cursor-pointer"
          >
            <span className="w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
              <i className={`${cat.icon} text-primary-600 text-sm`} />
            </span>
            <span className="text-sm text-foreground-800 group-hover:text-primary-700 whitespace-nowrap">
              {cat.name}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}